import { FIREBASE_EVENT_NAMES, FIREBASE_EVENT_PARAMS } from "utils/Constants";
import {
  Alert,
  Image,
  LayoutAnimation,
  Linking,
  Pressable,
  StyleSheet,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { Link, useLocalSearchParams, useRouter } from "expo-router";
import { Path, Svg } from "react-native-svg";
import React, { useEffect, useState } from "react";
import { fp, normalize, spH, spV, wp } from "utils/normalise";
import {
  getConfig,
  resetStoredUtilsSlice,
} from "appRedux/reducers/storedUtilsSlice";
import {
  getCountry,
  setCountries,
  setCountry,
  setCurrency,
} from "appRedux/reducers/storedUtilsSlice";
import { useDispatch, useSelector } from "react-redux";

import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Colors } from "colors";
import ImageView from "../../src/image";
import { Images } from "assets";
import PopupMenu from "./Popupmenu";
import Tooltip from "react-native-walkthrough-tooltip";
import VText from "./VText";
import { analytics } from "utils/firebaseConfig";
import { getFormatedCurrency } from "utils/common";
import headerData from "../utils/Header.json";
import { logEvent } from "firebase/analytics";
import menHeaderData from "../utils/Menheader.json";
import { resetAuthSlice } from "appRedux/reducers/authSlice";
import { resetCartSlice } from "appRedux/reducers/cartSlice";
import { resetFilterSlice } from "appRedux/reducers/filterSlice";
import { resetHomeSlice } from "appRedux/reducers/homeSlice";
import { resetOrderSlice } from "appRedux/reducers/orderSlice";
import { resetProfileSlice } from "appRedux/reducers/profileSlice";
import { resetUtilsSlice } from "appRedux/reducers/utilsSlice";
import { trackV2 } from "utils/Segment";

const Header = ({ gender }) => {
  const [selectedGender, setSelectedGender] = useState("women");
  const [showPopup, setShowPopup] = useState(false);
  const [activeSubcategory, setActiveSubcategory] = useState(null);
  const [subcategoryData, setSubcategoryData] = useState([]);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [search, setSearch] = useState("");

  const userProfile = useSelector((state) => state.ProfileReducer.profileData);
  const _loginModalRef = useSelector(
    (state) => state.UtilsReducer._loginModalRef
  );
  const _countryModalRef = useSelector(
    (state) => state.UtilsReducer._countryModalRef
  );
  const _closetModalRef = useSelector(
    (state) => state.UtilsReducer._closetModalRef
  );
  const _outfitModalRef = useSelector(
    (state) => state.UtilsReducer._outfitModalRef
  );
  const cart = useSelector((state) => state.CartReducer.cart);
  const _checkoutPopUp = useSelector(
    (state) => state.UtilsReducer._checkoutPopUp
  );
  const country = useSelector((state) => state.StoredutilsSlice.country);
  const currency = useSelector((state) => state.StoredutilsSlice.currency);
  const router = useRouter();
  const local = useLocalSearchParams(); 
  const localGender = local?.gender || "female";
  const headerDataArray = localGender === "men" ? menHeaderData : headerData;

  const dispatch = useDispatch();

  const handleMouseLeave = () => {
    setShowPopup(false);
  };

  useEffect(() => {
    featchcountry();
  }, []);

  const featchcountry = async () => {
    let IPisChanged = await AsyncStorage.getItem("IPisChanged");

    if (IPisChanged == "true") {
      dispatch(getCountry()).then((res) => {
        if (res?.payload?.data?.data?.allCountries) {
          let IPBasedCountry = res?.payload?.data?.data?.country;
          let countryData = res?.payload?.data?.data?.allCountries;
          countryData = countryData.filter(
            (item) => item.name !== IPBasedCountry
          );
          countryData.unshift({
            name: IPBasedCountry,
            imageUrl: res?.payload?.data?.data?.allCountries.find(
              (item) => item.name == res?.payload?.data?.data?.country
            )?.imageUrl,
            currency: res?.payload?.data?.data?.currency,
          });

          dispatch(setCountries(countryData));

          if (country == undefined) {
            let data = {
              name: res?.payload?.data?.data?.country,
              imageUrl: res?.payload?.data?.data?.allCountries.find(
                (item) => item.name == res?.payload?.data?.data?.country
              )?.imageUrl,
              currency: res?.payload?.data?.data?.currency,
            };
            dispatch(setCurrency(res?.payload?.data?.data?.currency?.[0]));
            dispatch(setCountry(data));
          } else {
            if (userProfile?.isGuest) {
              if (country?.name != res?.payload?.data?.data?.country) {
                if (_countryModalRef?.current) {
                  setTimeout(() => {
                    _countryModalRef?.current?.show();
                  }, 2000);
                }
              }
            } else {
              if (country?.name != res?.payload?.data?.data?.country) {
                if (_countryModalRef?.current) {
                  setTimeout(() => {
                    _countryModalRef?.current?.show();
                  }, 2000);
                }
              }
            }
          }
          AsyncStorage.setItem("IPisChanged", "false");
        }
      });
    }
  };

  // const [currentCountry, setCurrentCountry] = useState(AsyncStorage.getItem("country"));

  return (
    <View style={styles.container}>
      <View style={styles.topBar}>
        <VText style={styles.topBarText}>
          <Link href="/" aria-label="Women" target="_blank" >
            <TouchableOpacity
              activeOpacity={0.8}
              onPress={() => {
                const eventData = {
                  from_section: "Men",
                  to_section: "Women",
                };
                trackV2(ANALYTICS_EVENT_NAMES.SECTION_SWITCHED, eventData);
                setSelectedGender("female");
              }}
            >
              <VText
                style={[
                  styles.link,
                  {
                    color:
                      localGender === "female"
                        ? "rgba(0, 0, 0, 1)"
                        : "rgba(0, 0, 0, 0.6)",
                  },
                ]}
              >
                {"WOMEN"}
              </VText>
            </TouchableOpacity>
          </Link>
          <Link href="/men" aria-label="Men" target="_blank" >
            <TouchableOpacity
              activeOpacity={0.8}
              onPress={() => {
                const eventData = {
                  from_section: "Women",
                  to_section: "Men",
                };
                trackV2(ANALYTICS_EVENT_NAMES.SECTION_SWITCHED, eventData);
              }}
            >
              <VText
                style={[
                  styles.link,
                  {
                    color:
                      localGender === "men"
                        ? "rgba(0, 0, 0, 1)"
                        : "rgba(0, 0, 0, 0.6)",
                    paddingLeft: spH(31),
                  },
                ]}
              >
                MEN
              </VText>
            </TouchableOpacity>
          </Link>
        </VText>
        <VText style={styles.topBarText}>
          Need help,{" "}
          <Link
            aria-label="Contact Us"
            href={`${localGender == 'men' ? '/men' : ''}/contact-us`}
            onPress={() => {
              const eventData = {
                current_section: localGender === "female" ? "Women" : "Men",
              };
              trackV2(ANALYTICS_EVENT_NAMES.CONTACT_US_CLICKED, eventData);
            }}
          >
            <VText style={[styles.link, { textDecorationLine: "underline" }]}>
              Contact Us
            </VText>
          </Link>
        </VText>
      </View>
      <View style={styles.headerContainer}>
        <TouchableOpacity
          style={styles.countryContainer}
          onPress={() => _countryModalRef?.current?.show()}
        >
          <Image
            accessibilityLabel={country?.name}
            source={country?.imageUrl}
            style={{ width: spH(20), height: spH(20), borderRadius: 100 }}
          />
          <VText
            style={{
              color: "white",
              fontSize: fp(15),
              fontWeight: 300,
              marginTop: spH(4),
            }}
          >
            {country?.name}
          </VText>
        </TouchableOpacity>

        <TouchableOpacity
          activeOpacity={0.8}
          onPress={() => {
            router.push(`${localGender == "men" ? "/men" : ""}/`)
          }}
        >
          <Svg
            width="98"
            height="37"
            viewBox="0 0 98 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <Path
              d="M0 10.7137H7.32824L12.5267 29.126L17.8397 10.7137H24.8473L15.8473 35.6756H8.9542L0 10.7137Z"
              fill="white"
            />
            <Path
              d="M49.9237 28.3473C49.7557 29.8282 48.9847 31.3321 47.6107 32.8588C45.4733 35.2863 42.4809 36.5 38.6336 36.5C35.458 36.5 32.6565 35.4771 30.229 33.4313C27.8015 31.3855 26.5878 28.0573 26.5878 23.4466C26.5878 19.126 27.6794 15.813 29.8626 13.5076C32.0611 11.2023 34.9084 10.0496 38.4046 10.0496C40.4809 10.0496 42.3511 10.4389 44.0153 11.2176C45.6794 11.9962 47.0534 13.2252 48.1374 14.9046C49.1145 16.3855 49.7481 18.1031 50.0382 20.0573C50.2061 21.2023 50.2748 22.8511 50.2443 25.0038H33.1603C33.2519 27.5076 34.0382 29.2634 35.5191 30.271C36.4198 30.8969 37.5038 31.2099 38.771 31.2099C40.1145 31.2099 41.2061 30.8282 42.0458 30.0649C42.5038 29.6527 42.9084 29.0802 43.2595 28.3473H49.9237ZM43.4656 20.6985C43.3588 18.9733 42.8321 17.6679 41.8855 16.7824C40.9542 15.8817 39.7939 15.4313 38.4046 15.4313C36.8931 15.4313 35.7176 15.9046 34.8779 16.8511C34.0534 17.7977 33.5344 19.0802 33.3206 20.6985H43.4656ZM35.9313 0.5H41.7939L47.1527 7.34733H41.8397L38.8626 3.5L35.8626 7.34733H30.5496L35.9313 0.5Z"
              fill="white"
            />
            <Path
              d="M66.0916 31.0267V35.9046L63 36.0191C59.916 36.126 57.8092 35.5916 56.6794 34.416C55.9466 33.6679 55.5802 32.5153 55.5802 30.958V15.5916H52.0992V10.9427H55.5802V3.98092H62.0382V10.9427H66.0916V15.5916H62.0382V28.7824C62.0382 29.8053 62.1679 30.4466 62.4275 30.7061C62.687 30.9504 63.4809 31.0725 64.8092 31.0725C65.0076 31.0725 65.2137 31.0725 65.4275 31.0725C65.6565 31.0573 65.8779 31.042 66.0916 31.0267Z"
              fill="white"
            />
            <Path
              d="M76.9924 10.7137V35.6756H70.374V10.7137H76.9924ZM76.9924 1.71374V7.73664H70.374V1.71374H76.9924Z"
              fill="white"
            />
            <Path
              d="M95.8855 16.7366C93.2595 16.7366 91.4962 17.5916 90.5954 19.3015C90.0916 20.2634 89.8397 21.7443 89.8397 23.7443V35.6756H83.2672V10.7137H89.4962V15.0649C90.5038 13.4008 91.3817 12.2634 92.1298 11.6527C93.3511 10.6298 94.9389 10.1183 96.8931 10.1183C97.0153 10.1183 97.1145 10.126 97.1908 10.1412C97.2824 10.1412 97.4733 10.1489 97.7634 10.1641V16.8511C97.3511 16.8053 96.9847 16.7748 96.6641 16.7595C96.3435 16.7443 96.084 16.7366 95.8855 16.7366Z"
              fill="white"
            />
          </Svg>
        </TouchableOpacity>
        <View style={styles.searchContainer}>
          <View style={styles.searchInputContainer}>
            <Link
              aria-label="Search New Arrivals"
              href={`${localGender == 'men' ? '/men' : ''}/shop/new-arrivals?optionId=1&searchkey=${search}&title=New Arrivals`}
              onPress={() => {
                const eventData = {
                  query: search,
                  current_section: localGender === "female" ? "Women" : "Men",
                };
                trackV2(ANALYTICS_EVENT_NAMES.SEARCH_EXECUTED, eventData);
              }}
            >
              <Svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <Path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.331 17.0233C13.9147 18.069 18.3189 13.5766 17.0656 15.2843C17.097 15.2818 17.0388 15.3765 16.844 15.6138C16.844 15.6138 20.1911 18.9299 21.8341 20.6176C22.4045 21.2329 21.3753 22.4609 20.6761 21.8197C19.1883 20.3798 15.6676 16.8014 15.6622 16.7955L15.331 17.0233Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.7"
                />
                <Path
                  d="M10.4128 18.6999C12.5664 18.679 14.6983 17.7893 16.2313 16.2781C18.052 14.4832 18.9896 11.8278 18.6626 9.29253C18.1022 4.94821 14.5218 2 10.3593 2C7.19662 2 4.12303 3.9734 2.77483 6.83485C1.74277 9.02558 1.74068 11.6705 2.77483 13.865C4.11341 16.7064 7.13682 18.6694 10.3053 18.6999C10.3413 18.6999 10.3773 18.6999 10.4128 18.6999ZM10.3141 17.3079C7.09793 17.2771 4.0971 14.796 3.50036 11.6151C3.07968 9.37262 3.87379 6.94581 5.5281 5.35324C7.45923 3.49329 10.4948 2.87053 13.0189 3.9246C15.277 4.86771 16.9673 7.0576 17.2788 9.47023C17.5456 11.5383 16.8017 13.7057 15.3397 15.1986C14.0572 16.5083 12.2586 17.29 10.404 17.3079C10.3739 17.3079 10.3442 17.3079 10.3141 17.3079Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.7"
                />
              </Svg>
            </Link>

            <TextInput
              onChangeText={(text) => setSearch(text)}
              onKeyPress={(event) => {
                if (event.nativeEvent.key === "Enter") {
                  const eventData = {
                    query: search,
                    current_section: localGender === "female" ? "Women" : "Men",
                  };
                  trackV2(ANALYTICS_EVENT_NAMES.SEARCH_EXECUTED, eventData);
                  router.push(
                    `${
                      localGender == "men" ? "/men" : ""
                    }/shop/new-arrivals?optionId=1&searchkey=${search}&title=New Arrivals`
                  );
                }
              }}
              onFocus={() => {
                const eventData = {
                  current_section: localGender === "female" ? "Women" : "Men",
                };
                trackV2(ANALYTICS_EVENT_NAMES.SEARCH_INITIATED, eventData);
              }}
              style={styles.searchInput}
              placeholderTextColor={"#fff"}
              placeholder="SEARCH"
            />
          </View>
          <View style={styles.iconsContainer}>
            <Tooltip
              contentStyle={{
                backgroundColor: Colors.white,
              }}
              isVisible={tooltipVisible}
              backgroundColor="transparent"
              disableShadow={false}
              content={
                <View style={styles.tooltipContainer}>
                  <TouchableOpacity
                    activeOpacity={0.8}
                    onPress={() => {
                      setTooltipVisible(false);
                      const eventData = {
                        current_section:
                          localGender === "female" ? "Women" : "Men",
                      };
                      const eventData2 = {
                        user_option: "my_account",
                      };
                      trackV2(
                        ANALYTICS_EVENT_NAMES.PROFILE_MENU_OPENED,
                        eventData
                      );
                      trackV2(
                        ANALYTICS_EVENT_NAMES.USER_OPTION_SELECTED,
                        eventData2
                      );

                      router.push(
                        `${localGender == "men" ? "/men" : ""}/profile`
                      );
                    }}
                    style={styles.tooltipItem}
                  >
                    <VText style={styles.tooltipItemText}>My Account</VText>
                  </TouchableOpacity>
                  <TouchableOpacity
                    activeOpacity={0.8}
                    onPress={async () => {
                      const eventData2 = {
                        user_option: "sign_out",
                      };
                      trackV2(
                        ANALYTICS_EVENT_NAMES.USER_OPTION_SELECTED,
                        eventData2
                      );
                      trackV2(
                        ANALYTICS_EVENT_NAMES.USER_SIGNED_OUT,
                        eventData2
                      );
                      setTooltipVisible(false);
                      await AsyncStorage.clear();
                      dispatch(resetAuthSlice());
                      dispatch(resetCartSlice());
                      dispatch(resetHomeSlice());
                      dispatch(resetOrderSlice());
                      dispatch(resetProfileSlice());
                      dispatch(resetUtilsSlice());
                      dispatch(resetStoredUtilsSlice());
                      dispatch(resetFilterSlice());

                      router.push(`/${localGender == "men" ? "/men" : ""}`);

                      dispatch(getConfig());
                    }}
                    style={styles.tooltipItem}
                  >
                    <VText style={styles.tooltipItemText}>Sign Out</VText>
                  </TouchableOpacity>
                </View>
              }
              placement="bottom"
              onClose={() => setTooltipVisible(false)}
            >
              <TouchableOpacity
                activeOpacity={0.8}
                onPress={() => {
                  if (userProfile?.userId && !userProfile?.isGuest) {
                    const eventData = {
                      user_status: "logged_in",
                    };
                    trackV2(ANALYTICS_EVENT_NAMES.USER_ICON_CLICKED, eventData);
                    setTooltipVisible(true);
                  } else {
                    _loginModalRef?.current?.show();
                  }
                }}
              >
                {userProfile?.profilePicUrl && (
                  <ImageView
                    source={
                      userProfile?.profilePicUrl
                        ? userProfile?.profilePicUrl
                        : Images.profile
                    }
                    resizeMode={ImageView.resizeMode.cover}
                    style={{
                      borderWidth: 1,
                      borderColor: Colors.greyBorder,
                      width: spH(22),
                      height: spH(22),
                      borderRadius: spH(11),
                    }}
                  />
                )}

                {!userProfile?.profilePicUrl && (
                  <Svg
                    width="26"
                    height="25"
                    viewBox="0 0 26 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <Path
                      d="M7.73379 9.52337C7.73379 12.4278 10.0954 14.7895 13 14.7895C15.9045 14.7895 18.2661 12.4277 18.2661 9.52315C18.2661 6.61877 15.9045 4.25698 13 4.25698C10.0954 4.25698 7.73379 6.61878 7.73379 9.52337ZM9.27399 9.52326C9.27399 7.46651 10.9432 5.79729 13 5.79729C15.0567 5.79729 16.7259 7.46673 16.7259 9.52326C16.7259 11.58 15.0567 13.2492 13 13.2492C10.9432 13.2492 9.27399 11.58 9.27399 9.52326Z"
                      fill="#fff"
                      stroke="#fff"
                      strokeWidth="0.3"
                    />
                    <Path
                      d="M0.85 12.5C0.85 19.2188 6.31276 24.65 13 24.65C19.6876 24.65 25.15 19.1876 25.15 12.5C25.15 5.8124 19.6876 0.35 13 0.35C6.31265 0.35 0.85 5.78119 0.85 12.5ZM2.39031 12.5C2.39031 6.66031 7.16036 1.89031 13 1.89031C18.8397 1.89031 23.6097 6.66031 23.6097 12.5C23.6097 18.3397 18.8397 23.1097 13 23.1097C7.16031 23.1097 2.39031 18.3397 2.39031 12.5Z"
                      fill="#fff"
                      stroke="#fff"
                      strokeWidth="0.3"
                    />
                    <Path
                      d="M5.38194 20.997L5.50746 21.0807L5.59042 20.9547C7.2371 18.4543 10.0118 16.9602 13 16.9602C15.9578 16.9602 18.7021 18.4238 20.3486 20.8632L20.432 20.9868L20.5561 20.904L21.5794 20.2219L21.7045 20.1385L21.6208 20.0135C19.7014 17.1502 16.4609 15.4198 13 15.4198C9.5076 15.4198 6.23572 17.1818 4.31647 20.1078L4.23481 20.2323L4.35869 20.3148L5.38194 20.997Z"
                      fill="#fff"
                      stroke="#fff"
                      strokeWidth="0.3"
                    />
                  </Svg>
                )}
              </TouchableOpacity>
            </Tooltip>
            <Pressable
              activeOpacity={0.8}
              onPress={() => {
                router.push(`${localGender == 'men' ? '/men' : ''}/checkout`);
                _checkoutPopUp?.current?.hide();
              }}
              onHoverIn={() => {
                const eventData = {
                  current_section: localGender === "female" ? "Women" : "Men",
                  cart_item_count: Array.isArray(cart?.cart)
                    ? cart?.cart?.reduce(
                        (accumulator, currentValue) =>
                          accumulator + currentValue?.quantity,
                        0
                      )
                    : 0,
                  cart_total_value: `$${
                    getFormatedCurrency(cart?.orderSummary?.totalAmount) ?? 0
                  }`,
                };

                trackV2(ANALYTICS_EVENT_NAMES.CART_VIEWED, eventData);
                _checkoutPopUp?.current?.show([], true, localGender);
              }}
            >
              <Svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <Path
                  d="M10.9404 2C9.41561 2 8.16576 3.25947 8.16576 4.80063V6.45148H5.32267C5.30195 6.45046 5.28122 6.45046 5.2605 6.45148C5.10876 6.46628 4.96701 6.53469 4.86006 6.64455C4.75324 6.75456 4.68803 6.89899 4.67585 7.05251L3.37728 22.2887C3.36207 22.4716 3.42337 22.6525 3.54627 22.7877C3.66917 22.9229 3.84251 22.9999 4.02411 23H19.9746C20.1565 23.0003 20.3301 22.9234 20.4533 22.7882C20.5765 22.653 20.6379 22.4718 20.6227 22.2887L19.3229 7.05254C19.3091 6.88877 19.2352 6.73599 19.1153 6.62467C18.9956 6.51334 18.8388 6.45152 18.676 6.45152H15.8342V4.80067C15.8342 3.2595 14.5881 2.00004 13.0633 2.00004L10.9404 2ZM10.9404 3.31249H13.0632C13.891 3.31249 14.5356 3.96375 14.5356 4.80063L14.5357 6.45148H9.46425V4.80063C9.46425 3.96394 10.1125 3.31249 10.9404 3.31249H10.9404ZM5.91757 7.76521H8.16602V9.71213L8.16587 9.71227C8.17095 9.94328 8.29588 10.1545 8.49457 10.2686C8.69342 10.3826 8.9369 10.3826 9.13573 10.2686C9.33458 10.1545 9.45951 9.94328 9.46443 9.71227V7.76521H14.5359V9.71227C14.541 9.94328 14.6658 10.1545 14.8646 10.2686C15.0634 10.3826 15.3069 10.3826 15.5056 10.2686C15.7045 10.1545 15.8294 9.94328 15.8345 9.71227V7.76536H18.0829L19.2661 21.6875H4.73441L5.91757 7.76521Z"
                  fill="white"
                  stroke="white"
                  strokeWidth="0.35"
                />
              </Svg>

              <View
                style={{
                  width: wp(12),
                  height: wp(12),
                  borderRadius: 100,
                  backgroundColor: "red",
                  position: "absolute",
                  alignItems: "center",
                  justifyContent: "center",
                  right: 0,
                  bottom: 0,
                }}
              >
                <VText
                  style={{
                    fontSize: fp(8),
                    lineHeight: fp(8),
                    color: "white",
                  }}
                  text={`${
                    Array.isArray(cart?.cart)
                      ? cart?.cart?.reduce(
                          (accumulator, currentValue) =>
                            accumulator + currentValue?.quantity,
                          0
                        )
                      : 0
                  }`}
                />
              </View>
            </Pressable>
          </View>
        </View>
      </View>
      <View onMouseLeave={handleMouseLeave} style={styles.bottomBar}>
        {headerDataArray.map((item, index) => (
          <View key={index} style={styles.navItemContainer}>
            <View style={styles.subcategoriesContainer}>
              {item.subcategories.map((subcategory, subIndex) =>
                subcategory?.url ? (
                  <Link
                    aria-label={subcategory?.title}
                    key={subIndex}
                    style={[styles.subcategoryItem]}
                    href={subcategory?.url || "#"}
                    onMouseEnter={() => {
                      if (
                        Array.isArray(subcategory?.subcategories) &&
                        subcategory?.subcategories?.length > 0
                      ) {
                        LayoutAnimation.configureNext(
                          LayoutAnimation.Presets.spring
                        );
                        setShowPopup(true);
                        setActiveSubcategory(subIndex);
                        setSubcategoryData(subcategory?.subcategories);
                      } else {
                        LayoutAnimation.configureNext(
                          LayoutAnimation.Presets.spring
                        );
                        setShowPopup(false);
                        setActiveSubcategory(null);
                        setSubcategoryData([]);
                      }
                    }}
                    onPress={() => {
                      if (subcategory?.url) {
                        const eventData = {
                          current_section:
                            localGender === "female" ? "Women" : "Men",
                          parent_nav_item: subcategory?.title,
                        };
                        trackV2(
                          ANALYTICS_EVENT_NAMES.NAV_DROPDOWN_ITEM_CLICKED,
                          eventData
                        );
                      } else {
                        setShowPopup(true);
                        setSubcategoryData(subcategory?.subcategories);
                        setActiveSubcategory(subIndex);
                      }
                    }}
                  >
                    <VText style={styles.subcategoryText}>
                      {subcategory.title}{" "}
                    </VText>
                    {showPopup && activeSubcategory === subIndex && (
                      <View style={styles.popupMenu}>
                        <PopupMenu
                          visible={showPopup}
                          options={subcategoryData}
                          onSelect={(option) => {
                            setShowPopup(false);
                            const eventData = {
                              current_section:
                                localGender === "female" ? "Women" : "Men",
                              parent_nav_item: subcategory?.title,
                              subcategory: option?.title,
                            };
                            trackV2(
                              ANALYTICS_EVENT_NAMES.NAV_DROPDOWN_ITEM_CLICKED,
                              eventData
                            );
                          }}
                        />
                      </View>
                    )}
                  </Link>
                ) : (
                  <Pressable
                    key={subIndex}
                    style={[styles.subcategoryItem]}
                    onHoverIn={() => {
                      if (
                        Array.isArray(subcategory?.subcategories) &&
                        subcategory?.subcategories?.length > 0
                      ) {
                        LayoutAnimation.configureNext(
                          LayoutAnimation.Presets.spring
                        );
                        setShowPopup(true);
                        setActiveSubcategory(subIndex);
                        setSubcategoryData(subcategory?.subcategories);
                      } else {
                        LayoutAnimation.configureNext(
                          LayoutAnimation.Presets.spring
                        );
                        setShowPopup(false);
                        setActiveSubcategory(null);
                        setSubcategoryData([]);
                      }
                    }}
                    onPress={() => {
                      if (subcategory?.url) {
                        const eventData = {
                          current_section:
                            localGender === "female" ? "Women" : "Men",
                          parent_nav_item: subcategory?.title,
                        };
                        trackV2(
                          ANALYTICS_EVENT_NAMES.NAV_DROPDOWN_ITEM_CLICKED,
                          eventData
                        );
                        router.push(subcategory?.url);
                      } else {
                        setShowPopup(true);
                        setSubcategoryData(subcategory?.subcategories);
                        setActiveSubcategory(subIndex);
                      }
                    }}
                  >
                    <VText style={styles.subcategoryText}>
                      {subcategory.title}{" "}
                    </VText>
                    {showPopup && activeSubcategory === subIndex && (
                      <View style={styles.popupMenu}>
                        <PopupMenu
                          visible={showPopup}
                          options={subcategoryData}
                          onSelect={(option) => {
                            setShowPopup(false);
                            const eventData = {
                              current_section:
                                localGender === "female" ? "Women" : "Men",
                              parent_nav_item: subcategory?.title,
                              subcategory: option?.title,
                            };
                            trackV2(
                              ANALYTICS_EVENT_NAMES.NAV_DROPDOWN_ITEM_CLICKED,
                              eventData
                            );
                          }}
                        />
                      </View>
                    )}
                  </Pressable>
                )
              )}
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    zIndex: 10,
  },
  topBar: {
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
    backgroundColor: "rgba(255, 255, 255, 1)",
    paddingVertical: spV(8),
    paddingHorizontal: spH(40),
  },
  headerContainer: {
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: spH(12),
    paddingHorizontal: spH(16),
    backgroundColor: "rgba(0, 0, 0, 1)",
  },
  topBarText: {
    color: "rgba(0, 0, 0, 1)",
    fontWeight: "300",
    fontFamily: "JosefinSans",
    fontSize: 18,
  },
  link: {
    fontWeight: "500",
    fontSize: fp(14),
    fontFamily: "JosefinSans",
  },
  logo: {
    fontFamily: "JosefinSans",
    fontSize: normalize(34),
    fontWeight: "bold",
    marginTop: spV(10),
  },
  searchContainer: {
    position: "absolute",
    right: spH(40),
    flexDirection: "row",
    alignItems: "center",
  },

  countryContainer: {
    position: "absolute",
    top: spH(20),
    left: spH(40),
    flexDirection: "row",
    alignItems: "center",
    gap: spH(8),
  },
  searchInputContainer: {
    paddingBottom: spV(7),
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#fff",
    alignItems: "center",
  },
  searchInput: {
    marginLeft: 8,
    fontFamily: "JosefinSans",
    borderWidth: 0,
    color: "#fff",
    marginBottom: spV(-7),
    fontWeight: "350",
    outlineStyle: "none",
  },
  iconsContainer: {
    flexDirection: "row",
    marginLeft: spH(8),
    gap: spH(8),
    alignItems: "center",
    justifyContent: "flex-end",
  },
  navBar: {
    marginLeft: spH(290),
    flexDirection: "row",
    backgroundColor: Colors.white,
  },
  navItem: {
    marginHorizontal: 18,
  },
  navItemText: {
    fontSize: 22,
    lineHeight: 24,
    fontFamily: "JosefinSans",
    fontWeight: "350",
  },
  selectedNavItemText: {
    fontSize: 24,
    lineHeight: 28,
    fontFamily: "JosefinSans",
    fontWeight: "550",
  },
  selectedGender: {
    borderBottomWidth: 4,
    borderBottomColor: "#000",
  },
  bottomBar: {
    backgroundColor: "black",
    paddingVertical: spV(12),
    width: "100%",
  },
  navItemContainer: {},
  subcategoriesContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    paddingHorizontal: spH(90),
    justifyContent: "space-between",
  },
  subcategoryItem: {
    // paddingRight: spH(12),
  },
  subcategoryText: {
    color: "#fff",
    fontSize: fp(14),
    fontFamily: "JosefinSans",
    fontWeight: "300",
  },
  popupMenu: {
    top: spV(30),
    left: -spH(1),
    right: 0,
    bottom: 0,
    position: "absolute",
    zIndex: 10,
  },
  tooltipContainer: {
    paddingHorizontal: spH(10),
    borderRadius: 5,
    minWidth: 150,
  },
  tooltipItem: {
    paddingVertical: spV(5),
  },
  tooltipItemText: {
    fontSize: fp(14),
    fontFamily: "JosefinSans",
    fontWeight: "300",
  },
});

export default React.memo(Header);
